export const ITEM_KEYS = Array.from({ length: 10 }, (_, index) => `item${index + 1}`);
export const ITEM_STOCK_KEYS = Array.from({ length: 10 }, (_, index) => `itemStock${index + 1}`);

const toNumber = (value) => {
    if (value === '' || value === null || value === undefined) {
        return null;
    }

    const parsed = Number(value);
    return Number.isNaN(parsed) ? null : parsed;
};

export const isEnabledFlag = (value) =>
    value === true || value === 1 || ['1', 'true', 'on', 'si', 'sí', 'yes'].includes(String(value || '').toLowerCase());

export const isCustomPrice = (producto = {}) => isEnabledFlag(producto?.precioPersonalizable);

export const isStockNotRequired = (producto = {}) => isEnabledFlag(producto?.stockNoNecesario);

export const hasPerItemStock = (producto = {}) =>
    ITEM_STOCK_KEYS.some((key) => producto?.[key] !== '' && producto?.[key] !== null && producto?.[key] !== undefined);

export const hasConfiguredVariants = (producto = {}) =>
    ITEM_KEYS.some((key) => String(producto?.[key] || '').trim() !== '')
    || hasPerItemStock(producto);

export const getTotalStockFromItemStocks = (data = {}) =>
    ITEM_STOCK_KEYS.reduce((total, key) => total + Math.max(0, toNumber(data?.[key]) || 0), 0);

export const getStockForItem = (producto = {}, itemName = '') => {
    if (isStockNotRequired(producto)) {
        return Number.POSITIVE_INFINITY;
    }

    const normalizedItemName = String(itemName || '').trim();

    if (!normalizedItemName) {
        return Math.max(0, Number(producto?.stock) || 0);
    }

    const itemIndex = ITEM_KEYS.findIndex((key) => String(producto?.[key] || '').trim() === normalizedItemName);
    if (itemIndex === -1) {
        return Math.max(0, Number(producto?.stock) || 0);
    }

    const perItemStock = toNumber(producto?.[ITEM_STOCK_KEYS[itemIndex]]);
    if (perItemStock !== null) {
        return Math.max(0, perItemStock);
    }

    return Math.max(0, Number(producto?.stock) || 0);
};

export const getItemOptions = (producto = {}) =>
    ITEM_KEYS.map((itemKey, index) => {
        const label = String(producto?.[itemKey] || '').trim();
        if (!label) {
            return null;
        }

        return {
            label,
            stock: getStockForItem(producto, label),
            stockKey: ITEM_STOCK_KEYS[index],
            itemKey,
        };
    }).filter(Boolean);

export const normalizeCartItems = (rawCart = []) => {
    const grouped = new Map();

    if (!Array.isArray(rawCart)) {
        return [];
    }

    rawCart.forEach((entry) => {
        const idProducto = Number(entry?.idProducto);
        if (!idProducto) {
            return;
        }

        const cantidad = Math.max(0, Number(entry?.cantidad) || 0);
        if (cantidad === 0) {
            return;
        }

        const items = Array.isArray(entry?.item)
            ? entry.item
            : [entry?.item];

        const normalizedItems = items
            .map((item) => String(item || '').trim())
            .filter(Boolean);

        if (normalizedItems.length === 0) {
            const key = `${idProducto}::__no_variant__`;
            const current = grouped.get(key) || { idProducto, item: '', cantidad: 0 };
            current.cantidad += cantidad;
            grouped.set(key, current);
            return;
        }

        const counts = normalizedItems.reduce((acc, item) => {
            acc[item] = (acc[item] || 0) + 1;
            return acc;
        }, {});

        const counted = Object.values(counts).reduce((sum, current) => sum + current, 0);
        if (cantidad > counted) {
            counts[normalizedItems[0]] = (counts[normalizedItems[0]] || 0) + (cantidad - counted);
        }

        Object.entries(counts).forEach(([item, itemCantidad]) => {
            const key = `${idProducto}::${item}`;
            const current = grouped.get(key) || { idProducto, item, cantidad: 0 };
            current.cantidad += itemCantidad;
            grouped.set(key, current);
        });
    });

    return Array.from(grouped.values());
};

export const serializeCartItems = (cartItems = []) =>
    cartItems.map((item) => ({
        idProducto: item.idProducto,
        item: item.item,
        cantidad: item.cantidad,
    }));

export const getStoredCartItems = () => {
    try {
        return normalizeCartItems(JSON.parse(localStorage.getItem('cart')) || []);
    } catch (error) {
        localStorage.removeItem('cart');
        return [];
    }
};
